module.exports = __webpack_public_path__ + "img/responsibilty.3d8f6e4a.svg";